import { useT } from '~/i18n';
import { API_BASE } from '~/lib/api';

/**
 * Google rechazó el token de Gmail (revocado, vencido o sin permisos): el
 * servidor deja de generar y de enviar hasta que la persona reconecte. Va en
 * coral, encima de todo, para que nadie crea que se está postulando por él.
 *
 * Reconectar trae un token nuevo y `gmail_reconnect_required` se apaga solo.
 */
export default function GmailReconnectNotice({ required }: { required: boolean }) {
  const t = useT('workspace').dashboard;
  if (!required) return null;

  return (
    <div role="alert" className="alert alert-warning text-sm flex flex-col items-start gap-2">
      <span>
        <strong>{t.gmailDead.title}.</strong> {t.gmailDead.body}
      </span>
      <a href={`${API_BASE}/job-apply/auth/start`} className="btn btn-primary btn-sm">
        {t.reconnectGmail}
      </a>
    </div>
  );
}
